import React, { Component } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { showNotification } from '../../../action/NotificationAction';
import {
    getEducatorsBySubjectAndSubcategoryId,
    getSessionSubCategoryList,
} from '../../../action/Admin/LevelThreeAction';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import { customStyles } from '../../../../utils/Utility';
import { getReferralStudentList } from '../../../action/educator/AppointmentAction';
import store from '../../../../sessionStorage';

class StudentReferralModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subjectId: '',
            subCategoryId: '',
            educatorId: '',
            studentId: '',
            studentUserId: '',
            dropdownSubcategoryList: [],
            dropdownSubjectList: [],
            educatorList: [],
            studentList: [],
            options: [],
            isStudentLoading: false,
            isSubjectLoading: false,
            isSubcategoryLoading: false,
            isEducatorLoading: false,
        };
    }

    //getSessionSubCategoryList
    getSessionSubCategoryList(data) {
        this.setState({ dropdownSubcategoryList: [], isSubcategoryLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getSessionSubCategoryList(data, values, (result) => {
            this.setState({ isSubcategoryLoading: false });
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    dropdownSubcategoryList: result.response.data,
                });
            } else {
                this.setState({
                    dropdownSubcategoryList: [],
                });
            }
        });
    }

    //getEducatorsBySubjectAndSubcategoryId
    getEducatorsBySubjectAndSubcategoryId(id) {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
            isReferral: true,
        };
        this.props.getEducatorsBySubjectAndSubcategoryId(
            id,
            this.state.subjectId.value,
            values,
            (result) => {
                this.setState({ isEducatorLoading: false });
                if (result) {
                    this.setState({
                        educatorList: result.response.data,
                    });
                }
            }
        );
    }

    //getReferralStudentList
    getReferralStudentList(id, ownerId) {
        console.log('Fetching students for Owner ID:', ownerId);
        this.setState({ isStudentLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
            ownerId: ownerId,
        };
        this.props.getReferralStudentList(id, values, (result) => {
            this.setState({ isStudentLoading: false });
            if (result) {
                this.setState({
                    studentList: result.response.data,
                });
            }
        });
    }

    //customOptionLabel
    customOptionLabel = ({ label }) => (
        <div className="overflow-hidden truncate" title={label}>
            {label}
        </div>
    );

    //resetState
    resetState = () => {
        this.setState({
            subjectId: '',
            subCategoryId: '',
            educatorId: '',
            studentId: '',
            studentUserId: '',
            dropdownSubcategoryList: [],
            educatorList: [],
            studentList: [],
        });
    };

    render() {
        const { dropdownSubjectList, onChange } = this.props;
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={() => {
                    this.props.closeModal();
                    this.resetState();
                }}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-schedule">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-white">
                                Create Referral
                            </h3>
                            <button
                                type="button"
                                onClick={() => {
                                    this.props.closeModal();
                                    this.resetState();
                                }}
                            >
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div>
                            <div className="grid gap-4 sm:grid-cols-2">
                                <div>
                                    <label
                                        htmlFor="select-subject"
                                        className="block mb-2 text-base font-normal text-white mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                    >
                                        Select Channel
                                    </label>
                                    <Select
                                        isLoading={this.state.isSubjectLoading}
                                        id="subject"
                                        name="subject"
                                        onChange={(event) => {
                                            this.setState({
                                                subjectId: event || '',
                                                subCategoryId: '',
                                                educatorId: '',
                                                studentId: '',
                                                studentUserId: '',
                                            });
                                            if (event?.value) {
                                                this.getSessionSubCategoryList(event.value);
                                            }
                                        }}
                                        value={this.state.subjectId || undefined}
                                        ref={(r) => (this.subjectRef = r)}
                                        className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                        options={dropdownSubjectList.map((subject) => ({
                                            value: subject.id,
                                            label: subject.name,
                                        }))}
                                        styles={customStyles}
                                        placeholder="Select any Channel"
                                        isClearable={true}
                                        onKeyDown={(event) => {
                                            const key = event.key;
                                            const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                            if (
                                                !allowedCharacters.test(key) ||
                                                (event.keyCode === 32 &&
                                                    !this.subjectRef.state.inputValue)
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="select-subcategory"
                                        className="block mb-2 text-base font-normal rounded text-white mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                    >
                                        Select Element
                                    </label>
                                    <Select
                                        isLoading={this.state.isSubcategoryLoading}
                                        id="subcategory"
                                        name="subcategory"
                                        onChange={(event) => {
                                            this.setState({
                                                subCategoryId: event || '',
                                                educatorId: '',
                                                studentId: '',
                                                studentUserId: '',
                                            });
                                            if (event?.value) {
                                                this.getEducatorsBySubjectAndSubcategoryId(
                                                    event.value
                                                );
                                            }
                                        }}
                                        value={this.state.subCategoryId || undefined}
                                        ref={(r) => (this.subcategoryRef = r)}
                                        className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                        options={this.state.dropdownSubcategoryList.map(
                                            (subject) => ({
                                                value: subject.id,
                                                label: subject.name,
                                            })
                                        )}
                                        styles={customStyles}
                                        placeholder="Select any Element"
                                        isClearable={true}
                                        onKeyDown={(event) => {
                                            const key = event.key;
                                            const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                            if (
                                                !allowedCharacters.test(key) ||
                                                (event.keyCode === 32 &&
                                                    !this.subcategoryRef.state.inputValue)
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="grid gap-4 sm:grid-cols-2">
                                <div>
                                    <label
                                        htmlFor="select-educator"
                                        className="block mb-2 text-base font-normal text-white mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                    >
                                        Select Owner
                                    </label>
                                    <Select
                                        isLoading={this.state.isEducatorLoading}
                                        id="educator"
                                        name="educator"
                                        onChange={(selectedOption) => {
                                            this.setState({
                                                educatorId: selectedOption || '',
                                                studentId: '',
                                                studentUserId: '',
                                            });
                                            if (selectedOption) {
                                                this.getReferralStudentList(
                                                    store.get('userSession').levelThree.id,
                                                    selectedOption.educatorUserId
                                                );
                                            }
                                        }}
                                        value={this.state.educatorId || undefined}
                                        ref={(r) => (this.educatorRef = r)}
                                        className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                        options={
                                            this.state.educatorList &&
                                            this.state.educatorList.length
                                                ? this.state.educatorList
                                                : []
                                        }
                                        styles={customStyles}
                                        placeholder="Search and select by Owner"
                                        isClearable={true}
                                        onKeyDown={(event) => {
                                            const key = event.key;
                                            const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                            if (
                                                !allowedCharacters.test(key) ||
                                                (event.keyCode === 32 &&
                                                    !this.educatorRef.state.inputValue)
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                        formatOptionLabel={this.customOptionLabel}
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="select-student"
                                        className="block mb-2 text-base font-normal text-white mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                    >
                                        Select Team Member
                                    </label>
                                    <Select
                                        isLoading={this.state.isStudentLoading}
                                        id="student"
                                        name="student"
                                        onChange={(selectedOption) => {
                                            this.setState({
                                                studentId: selectedOption || '',
                                                studentUserId: selectedOption?.studentUserId || '',
                                            });
                                        }}
                                        value={this.state.studentId || undefined}
                                        ref={(r) => (this.selectRef = r)}
                                        className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                        options={this.state.studentList.map((student) => ({
                                            value: student.studentId,
                                            label: student.studentName,
                                            studentUserId: student.studentUserId,
                                        }))}
                                        styles={customStyles}
                                        placeholder="Search and select by Team Member"
                                        isClearable={true}
                                        onKeyDown={(event) => {
                                            const key = event.key;
                                            const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                            if (
                                                !allowedCharacters.test(key) ||
                                                (event.keyCode === 32 &&
                                                    !this.selectRef.state.inputValue)
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                        formatOptionLabel={this.customOptionLabel}
                                    />
                                </div>
                            </div>
                            <label
                                htmlFor="notesSummary"
                                className="block mt-6 mb-2 text-base font-normal text-white rounded "
                            >
                                Notes
                            </label>
                            <div className="py-1">
                                <textarea
                                    id="notesSummary"
                                    name="notesSummary"
                                    rows="3"
                                    onChange={onChange}
                                    placeholder="Summary can be added upto 500 characters"
                                    className="block w-full px-2 py-1 text-base text-white rounded bg-collaboratortable placeholder:text-secondary sm:text-lg"
                                    maxLength={500}
                                />
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-danger rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    this.props.closeModal();
                                    this.resetState();
                                }}
                            >
                                Cancel
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-UIprimary rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    const {
                                        educatorId,
                                        // studentId,
                                        studentUserId,
                                        subjectId,
                                        subCategoryId,
                                    } = this.state;
                                    if (
                                        educatorId.id &&
                                        studentUserId &&
                                        subjectId.value &&
                                        subCategoryId.value
                                    ) {
                                        this.props.submitCancelation(
                                            educatorId.id,
                                            studentUserId,
                                            studentUserId,
                                            subjectId.value,
                                            subCategoryId.value
                                        );
                                        this.props.setIsTabName('create');
                                        this.resetState();
                                        this.props.closeModal();
                                    }
                                }}
                                disabled={this.props.btnLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.btnLoading ? <Spinner color="#FFF" /> : 'Save'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapDispatchtoProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getSessionSubCategoryList: (id, values, callback) => {
            dispatch(getSessionSubCategoryList(id, values, callback));
        },
        getEducatorsBySubjectAndSubcategoryId: (subjectId, subCategoryId, values, callback) => {
            dispatch(
                getEducatorsBySubjectAndSubcategoryId(subjectId, subCategoryId, values, callback)
            );
        },
        getReferralStudentList: (id, values, callback) => {
            dispatch(getReferralStudentList(id, values, callback));
        },
    };
};

export default connect(null, mapDispatchtoProps)(StudentReferralModal);
